export default "__VITE_ASSET__BjBifYjd__"